// extracted by mini-css-extract-plugin
export default {"wrapper":"tab3_wrapper__FvPkW","instruction-link":"tab3_instruction-link__t35wH","grey":"tab3_grey__N+bLh","service":"tab3_service__Zx7B-","instrWrapper":"tab3_instrWrapper__xSRvr"};